import PropTypes from 'prop-types'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import { dotPath, isNilOrEmpty } from 'ramdasauce'

import { useStyles } from './styles'
import { Text } from 'components/atoms'

export const ProductTile = ({ data }) => {
  const classes = useStyles()

  const maxPrice = dotPath('priceRangeV2.maxVariantPrice.amount', data)
  const minPrice = dotPath('priceRangeV2.minVariantPrice.amount', data)

  const price =
    maxPrice === minPrice ? `$${maxPrice}0` : `$${maxPrice}0 - $${minPrice}0`

  return (
    <Link to={`/product/${data.urlSlug}`} className={classes.wrapper}>
      {!isNilOrEmpty(data.productImages) && (
        <GatsbyImage
          image={getImage(data.productImages[0])}
          alt={data.title}
          className={classes.image}
        />
      )}
      <Text className={classes.title} size="body3">
        {data.title}
      </Text>
      <Text className={classes.price} size="body4">
        {price}
      </Text>
    </Link>
  )
}

ProductTile.propTypes = {
  data: PropTypes.object,
}

ProductTile.defaultProps = {
  text: null,
}
